import { gql } from '@apollo/client'
import PropTypes from 'prop-types'
import externalPrimaryTicketShopFragment, {
  externalPrimaryTicketShopFragmentPropTypes,
} from '~/graphql/fragments/externalPrimaryTicketShop'

const externalPrimaryTicketShopAlertFragment = gql`
  fragment externalPrimaryTicketShopAlert on ExternalPrimaryTicketShopAlert {
    id
    state
    externalPrimaryTicketShop {
      ...externalPrimaryTicketShop
    }
  }

  ${externalPrimaryTicketShopFragment}
`

export const externalPrimaryTicketShopAlertFragmentPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  externalPrimaryTicketShop: externalPrimaryTicketShopFragmentPropTypes,
  state: PropTypes.oneOf(['ENABLED', 'DISABLED']).isRequired,
})

export default externalPrimaryTicketShopAlertFragment
